var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.mini
        ? _c(
            "v-container",
            {
              staticClass: "fill-height justify-center",
              attrs: { id: "userProfileSelect", tag: "section" }
            },
            [
              _c(
                "v-card",
                { attrs: { id: "accountSelection", width: "400" } },
                [
                  _c("v-card-title", { staticClass: "text-center" }, [
                    _vm._v(" " + _vm._s(_vm.$t("login.select-a-profile")) + " ")
                  ]),
                  _c("v-card-text", [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("login.profile-user-associated")) +
                        " "
                    )
                  ]),
                  _c("v-card-text", [
                    _vm.loading
                      ? _c("div", [_vm._v(" Loading ")])
                      : _c(
                          "div",
                          [
                            _c(
                              "v-list",
                              [
                                _vm._l(Object.entries(_vm.profiles), function(
                                  ref
                                ) {
                                  var key = ref[0]
                                  var profile = ref[1]
                                  return _c(
                                    "v-list-item",
                                    { key: key, staticClass: "pa-0" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            text: _vm.mini,
                                            color: "secondary",
                                            block: "",
                                            disabled: _vm.isActiveProfile(key)
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.setProfile(key)
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                profile.account.displayName
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                }),
                                _c(
                                  "v-list-item",
                                  { staticClass: "pa-0" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          text: _vm.mini,
                                          color: "blue",
                                          block: ""
                                        },
                                        on: { click: _vm.editProfileDialog }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("global.profile")) +
                                            " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c("hr"),
                                _c(
                                  "v-list-item",
                                  { staticClass: "pa-0" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          text: _vm.mini,
                                          color: "primary",
                                          block: ""
                                        },
                                        on: { click: _vm.logout }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("global.logout")) +
                                            " "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              2
                            )
                          ],
                          1
                        )
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.mini
        ? _c("div", [
            _vm.loading
              ? _c("div", [_vm._v(" Loading ")])
              : _c(
                  "div",
                  [
                    _c(
                      "v-list",
                      [
                        _c(
                          "v-list-item",
                          { staticClass: "pa-0" },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  text: _vm.mini,
                                  color: "blue",
                                  block: ""
                                },
                                on: { click: _vm.editProfileDialog }
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("global.profile")) + " "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: Object.entries(_vm.profiles).length > 1,
                                expression: "Object.entries(profiles).length>1"
                              }
                            ]
                          },
                          [
                            _c("hr"),
                            _vm._l(Object.entries(_vm.profiles), function(ref) {
                              var key = ref[0]
                              var profile = ref[1]
                              return _c(
                                "v-list-item",
                                { key: key, staticClass: "pa-0 account" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        text: _vm.mini,
                                        color: "secondary",
                                        block: "",
                                        disabled: _vm.isActiveProfile(key)
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.setProfile(key)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(profile.account.displayName) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            }),
                            _c("hr")
                          ],
                          2
                        ),
                        _c(
                          "v-list-item",
                          { staticClass: "pa-0" },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  text: _vm.mini,
                                  color: "primary",
                                  block: ""
                                },
                                on: { click: _vm.logout }
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("global.logout")) + " "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }